// Fetch Review Numbers
(function () {
  var selectors = [
    '.jdgm-rev-widg__summary-text.jdgm-all-reviews__summary-text--verified',
    '.jdgm-rev-widg__summary-text',                 
    '.jdgm-prev-badge__text', 
    '[data-number-of-reviews]'
  ];

  function findSourceEl() {
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function extractCountFromEl(el) {
    var attrCount = el.getAttribute && el.getAttribute('data-number-of-reviews');
    if (attrCount) return Number(attrCount);
    var txt = (el.textContent || '').replace(/\u00A0/g, ' ').trim();
    var m = txt.match(/(\d{1,3}(?:,\d{3})*)\s*(?:verified\s*)?reviews?/i);
    if (m && m[1]) return Number(m[1].replace(/,/g, ''));
    var nums = (txt.match(/\d{1,3}(?:,\d{3})*|\d+/g) || []).map(function(n){ return Number(n.replace(/,/g,'')); });
    if (nums.length) return Math.max.apply(Math, nums);

    return null;
  }

  function writeToHero(count) {
    var mount = document.getElementById('hero-reviews-count');
    if (!mount) return false;
    mount.textContent = count + ' reviews';
    return true;
  }

  function tryUpdate() {
    var source = findSourceEl();
    if (!source) return false;
    var count = extractCountFromEl(source);
    if (count == null || isNaN(count)) return false;
    return writeToHero(count);
  }
  if (tryUpdate()) return;
  var giveUpAt = Date.now() + 15000; // 15s safety
  var observer = new MutationObserver(function () {
    if (tryUpdate()) {
      observer.disconnect();
    } else if (Date.now() > giveUpAt) {
      observer.disconnect();
    }
  });
  observer.observe(document.documentElement || document.body, { childList: true, subtree: true });
  var tries = 0;
  var iv = setInterval(function () {
    tries++;
    if (tryUpdate() || tries > 60) clearInterval(iv);
  }, 500);
})();